export const CAMERA_FOV = 25
export const MIN_CAMERA_DISTANCE = 1
export const MAX_CAMERA_DISTANCE = 20
export const INITIAL_CAMERA_POSITION: [number, number, number] = [0, 0.65, 4.5]
export const INITIAL_ROTATION: [number, number, number] = [0, Math.PI * 0.25, 0]
export const MODEL_MAX_SIZE = 2
export const MASSAGE_ENGINES_HEIGHT = 0.375
